export default __webpack_public_path__ + "static/media/Kaspersky.77d4cc41.png";